<header class="masthead" style="position: fixed;">
	<div class="navbar">
		<div class="left-header-subscribe">
				<button id="create-workspace" class="back-to-workspace" data-toggle="dropdown" class="DAM-icon" (click)="switchToWorkspace()">
					<a class="navbar-brand js-scroll-trigger" href="javascript:;"><svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<title>Back</title>
							<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="DAM-Pricing-Copy-2" transform="translate(-40.000000, -28.000000)">
											<g id="Back" transform="translate(40.000000, 28.000000)">
													<rect id="Rectangle-8" x="0" y="0" width="24" height="24"></rect>
													<g id="Group-7" stroke-linecap="round" stroke-linejoin="round" transform="translate(3.000000, 6.000000)" stroke="#000000" stroke-width="1.5">
															<line x1="0" y1="6" x2="17.1428571" y2="6" id="Stroke-1"></line>
															<polyline id="Path-2" points="5.4 0 0 5.9256575 5.27460736 12"></polyline>
													</g>
											</g>
									</g>
							</g>
					</svg>
				</a>
					<span class="drop-down-option-workspace">
						Back to workspace
					</span>
				</button>
		</div>

		<div class="right-header">
			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
					<img *ngIf="!userPic" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
							</div>
							<div class="email">{{currentUser.email}}</div>
							<div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed <= 1000" class="storage-size">{{consumedSpaceAllowed | number: '1.2-2'}}MB / {{totalSpaceAllowed}}GB</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed}}GB</div>
							<div *ngIf="totalSpaceAllowed > 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed/1000}}TB</div>
							<!-- <div class="storage-indicator">
								<div class="storage-indicator-color">

								</div>
							</div> -->
							<progress id="file" value="{{consumedSpaceAllowed}}" max="{{totalSpaceAllowedProgress}}"></progress>
						</div>

						<ul class="dropdown-list list-group">
							<div class="hr-line"></div>
							<a routerLink="/my-profile"><li class="list-group-item">My profile</li></a>
							<a (click)="personalClick()"><li class="list-group-item">My content hub</li></a>
							<div class="hr-line"></div>
							<a routerLink="/how-it-works" target="_blank"><li class="list-group-item">How it works</li></a>
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a (click)="goToFeedback()"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
							<a (click)="goProClick()" *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section class="payment-success-section">
	<div class="container">
		<div class="row">
			<div class="col-sm-12 text-center">
				<div class="img-container">
					<img src="assets/img/confirmed.svg">
					<!-- <h1>${{totalAmount}}/-</h1> -->
					<h5>Your Payment is Successful!</h5>
					<p>Payment invoice will be shared with you via email shortly.</p>
					<a href="javascript:;" class="button" (click)="switchToWorkspace()">Go to Workspace</a>
				</div>
			</div>
		</div>
	</div>
</section>
